// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AudioRecorder_container__ou8vF {
    display: flex;
    align-items: center;
    border: 1px solid var(--color-lightui-surface-4);
    border-radius: 4px;
    height: 69px;
    padding: 0px 8px;
    gap: 8px;
}

.AudioRecorder_containerNoBorder__evGKW {
    display: flex;
    align-items: center;
    height: 69px;
    padding: 0px 8px;
    gap: 8px
}

.AudioRecorder_containerHighlighted__iQN\\+x {
    border-color: var(--color-blue-primary);
}

.AudioRecorder_icon__si43k {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
}

.AudioRecorder_iconWrapperDark__gyocH,
.AudioRecorder_iconWrapper__iFQoI {
    width: 24px;
    height: 24px;
    cursor: pointer;
    background-color: var(--color-darkui-accent-2);
    border-radius: 50%;
}

.AudioRecorder_iconWrapperDark__gyocH {
    background-color: var(--color-darkui-surface-4);
}

.AudioRecorder_iconWrapper__iFQoI::before {
    vertical-align: text-bottom;
}

.AudioRecorder_message__4Yzlu {
    height: 55px;
    color: var(--color-secondary);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: left;
}

.AudioRecorder_content__dA2UP {
    display: flex;
    flex-grow: 1;
    align-items: center;
}

.AudioRecorder_recorderTimer__Mw38C {
    margin-right: 8px;
}

.AudioRecorder_recorderWaveform__Lu0Co {
    display: flex;
    flex: 1;
    justify-content: flex-start;
}

.AudioRecorder_deleteBtn__SQgq5 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: var(--color-lightui-surface-4);
}
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/AudioRecorder/AudioRecorder.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,gDAAgD;IAChD,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,OAAO;IACP,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gDAAgD;AACpD","sourcesContent":[".container {\n    display: flex;\n    align-items: center;\n    border: 1px solid var(--color-lightui-surface-4);\n    border-radius: 4px;\n    height: 69px;\n    padding: 0px 8px;\n    gap: 8px;\n}\n\n.containerNoBorder {\n    display: flex;\n    align-items: center;\n    height: 69px;\n    padding: 0px 8px;\n    gap: 8px\n}\n\n.containerHighlighted {\n    border-color: var(--color-blue-primary);\n}\n\n.icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n}\n\n.iconWrapperDark,\n.iconWrapper {\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    background-color: var(--color-darkui-accent-2);\n    border-radius: 50%;\n}\n\n.iconWrapperDark {\n    background-color: var(--color-darkui-surface-4);\n}\n\n.iconWrapper::before {\n    vertical-align: text-bottom;\n}\n\n.message {\n    height: 55px;\n    color: var(--color-secondary);\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n    letter-spacing: 0px;\n    text-align: left;\n}\n\n.content {\n    display: flex;\n    flex-grow: 1;\n    align-items: center;\n}\n\n.recorderTimer {\n    margin-right: 8px;\n}\n\n.recorderWaveform {\n    display: flex;\n    flex: 1;\n    justify-content: flex-start;\n}\n\n.deleteBtn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    background-color: var(--color-lightui-surface-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AudioRecorder_container__ou8vF`,
	"containerNoBorder": `AudioRecorder_containerNoBorder__evGKW`,
	"containerHighlighted": `AudioRecorder_containerHighlighted__iQN+x`,
	"icon": `AudioRecorder_icon__si43k`,
	"iconWrapperDark": `AudioRecorder_iconWrapperDark__gyocH`,
	"iconWrapper": `AudioRecorder_iconWrapper__iFQoI`,
	"message": `AudioRecorder_message__4Yzlu`,
	"content": `AudioRecorder_content__dA2UP`,
	"recorderTimer": `AudioRecorder_recorderTimer__Mw38C`,
	"recorderWaveform": `AudioRecorder_recorderWaveform__Lu0Co`,
	"deleteBtn": `AudioRecorder_deleteBtn__SQgq5`
};
export default ___CSS_LOADER_EXPORT___;
